export default {
	'stock-quantities': 'Stock Quantities',
	'sample-name': 'Item Name',
	remaining: 'Remaining',
	'no-samples-to-show': 'NO ITEMS TO SHOW',
	'sort-by': 'Sort by'
}